var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotGoingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.6646C15.748 19.6646 19.6577 15.7549 19.6577 11.0068C19.6577 6.26709 15.7397 2.34912 10.9917 2.34912C6.25195 2.34912 2.34229 6.26709 2.34229 11.0068C2.34229 15.7549 6.25195 19.6646 11 19.6646ZM8.31885 14.543C7.8457 14.543 7.47217 14.1694 7.47217 13.6797C7.47217 13.4639 7.56348 13.248 7.72119 13.0903L9.78809 11.0234L7.72119 8.94824C7.56348 8.79053 7.47217 8.57471 7.47217 8.35889C7.47217 7.87744 7.8457 7.50391 8.31885 7.50391C8.57617 7.50391 8.76709 7.58691 8.93311 7.75293L11 9.81152L13.0835 7.74463C13.2578 7.57031 13.4487 7.49561 13.6978 7.49561C14.1709 7.49561 14.5444 7.86914 14.5444 8.34229C14.5444 8.57471 14.4697 8.77393 14.2954 8.94824L12.2202 11.0234L14.2871 13.082C14.4531 13.2397 14.5361 13.4556 14.5361 13.6797C14.5361 14.1694 14.1626 14.543 13.6812 14.543C13.4321 14.543 13.2163 14.46 13.0586 14.2939L11 12.2354L8.94971 14.2939C8.78369 14.46 8.57617 14.543 8.31885 14.543Z",
    fill: "#FF3B30"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotGoingIcon);
export default __webpack_public_path__ + "static/media/notGoingIcon.dbfcebf14da91ca944a7c28d34793ecb.svg";
export { ForwardRef as ReactComponent };